// Stub for Input — xtracker handles its own keyboard input via DOM events.
var Input = function(){
	var me = {};
	var currentOctave = 4;
	me.getCurrentOctave = function(){ return currentOctave; };
	me.setCurrentOctave = function(o){ currentOctave = o; };
	me.clearInputNotes = function(){};
	me.handleNoteOn = function(){};
	me.handleNoteOff = function(){};
	me.isMetaKeyDown = function(){ return false; };
	return me;
}();

export default Input;
